import React from "react";
import { Check, Minus } from "lucide-react";

const ROWS = [
    { feature: "Live orbital GIS map, ice overlay & measure tool", free: true, pro: true },
    { feature: "Ground Sciences Lab (geology, soil, geomorphology, geophysics)", free: true, pro: true },
    { feature: "Discipline quizzes & progress tracking", free: true, pro: true },
    { feature: "Research projects, map pins & findings", free: true, pro: true },
    { feature: "Exportable scientific reports", free: true, pro: true },
    { feature: "Guided learning path", free: true, pro: true },
    { feature: "AI terrain classifier (Gemini vision)", free: false, pro: "Unlimited" },
    { feature: "Subsurface telemetry hub & charts", free: false, pro: true },
    { feature: "Manage or cancel billing anytime", free: false, pro: true },
];

function Mark({ value, testid }) {
    if (value === true) return <Check className="w-4 h-4 text-ares-emerald mx-auto" data-testid={testid} />;
    if (!value) return <Minus className="w-4 h-4 text-ares-muted/60 mx-auto" data-testid={testid} />;
    return <span className="font-mono text-xs text-ares-orange" data-testid={testid}>{value}</span>;
}

export default function PlanComparison({ active }) {
    return (
        <div className="mt-10 rounded-2xl border border-ares-border bg-ares-dark/90 overflow-hidden" data-testid="plan-comparison-table">
            <div className="px-6 py-4 border-b border-ares-border">
                <h3 className="font-heading text-lg font-semibold">Free vs Pro</h3>
                <p className="text-xs text-ares-muted mt-0.5">Exactly what each plan includes.</p>
            </div>
            <table className="w-full text-sm">
                <thead>
                    <tr className="font-mono text-[10px] uppercase tracking-widest text-ares-muted">
                        <th className="text-left px-6 py-3 font-normal">Feature</th>
                        <th className={`w-28 py-3 font-normal ${!active ? "text-ares-bright" : ""}`} data-testid="comparison-col-free">Free</th>
                        <th className={`w-28 py-3 font-normal text-ares-orange ${active ? "bg-ares-orange/10" : ""}`} data-testid="comparison-col-pro">Pro</th>
                    </tr>
                </thead>
                <tbody>
                    {ROWS.map((r, i) => (
                        <tr key={r.feature} className="border-t border-ares-border/60 hover:bg-ares-panel/40 transition-colors" data-testid={`comparison-row-${i}`}>
                            <td className="px-6 py-3 text-ares-bright/90">{r.feature}</td>
                            <td className="text-center py-3"><Mark value={r.free} testid={`comparison-free-${i}`} /></td>
                            <td className="text-center py-3 bg-ares-orange/5"><Mark value={r.pro} testid={`comparison-pro-${i}`} /></td>
                        </tr>
                    ))}
                    <tr className="border-t border-ares-border">
                        <td className="px-6 py-3 font-mono text-[11px] uppercase tracking-widest text-ares-muted">Price</td>
                        <td className="text-center py-3 font-semibold">$0</td>
                        <td className="text-center py-3 bg-ares-orange/5 font-semibold text-ares-orange text-xs">$9.99/mo<br />or $99.99/yr</td>
                    </tr>
                </tbody>
            </table>
        </div>
    );
}
